import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const exportToExcel = (jsonData, fileName) => {
   var datos = [];
   var filtro = 2;
   // Crear hoja a partir de JSON
   if (fileName === "insumostattoo") filtro = 1;

   if (fileName === "insumos" || fileName === "insumostattoo") {
      datos = jsonData
         .filter((item) => item.tipo !== filtro) // keep only rows where tipo is NOT 2
         .map((item) => ({
            id: item.id_primary,
            Descripcion: item.descripcion,
            Stock: item.stock,
            Precio: item.dolar,
         }));
   } else {
      datos = jsonData;
   }

   const worksheet = XLSX.utils.json_to_sheet(datos);

   // Crear libro y añadir la hoja
   const workbook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

   // Generar buffer y guardarlo
   const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
   });
   const data = new Blob([excelBuffer], { type: "application/octet-stream" });

   saveAs(data, `${fileName}.xlsx`);
};

export default exportToExcel;
